(() => {
  const instances = new Map();
  const sliderUtils = window.AWSliderCoreUtils;

  class AWProductRelatedItems {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-aw-product-related-items-viewport]");
      this.list = root.querySelector("[data-aw-product-related-items-list]");
      this.scrollbar = root.querySelector("[data-aw-product-related-items-scrollbar]");
      this.thumb = root.querySelector("[data-aw-product-related-items-scrollbar-thumb]");
      this.prevButton = root.querySelector("[data-aw-product-related-items-prev]");
      this.nextButton = root.querySelector("[data-aw-product-related-items-next]");
      this.rafId = null;
      this.resizeId = null;

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onImageLoad = this.onImageLoad.bind(this);

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      window.addEventListener("resize", this.onResize);

      sliderUtils.bindImageLoad(this.root, this.onImageLoad);
    }

    destroy() {
      if (this.prevButton) {
        this.prevButton.removeEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.removeEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.resizeId) {
        window.cancelAnimationFrame(this.resizeId);
        this.resizeId = null;
      }
    }

    getItemDistance() {
      if (!this.list) return 0;

      const item = this.list.children[0];
      if (!item) return 0;

      return sliderUtils.getItemDistance({
        list: this.list,
        itemSelector: "[data-aw-product-related-items-item]",
        viewport: this.viewport
      });
    }

    scroll(direction) {
      if (!this.viewport) return;

      this.viewport.scrollBy({
        left: direction * this.getItemDistance(),
        behavior: "smooth"
      });
    }

    onPrevClick() {
      if (this.prevButton && this.prevButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(-1);
    }

    onNextClick() {
      if (this.nextButton && this.nextButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(1);
    }

    onScroll() {
      if (this.rafId) return;

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    onResize() {
      if (this.resizeId) return;

      this.resizeId = window.requestAnimationFrame(() => {
        this.resizeId = null;
        this.update();
      });
    }

    onImageLoad() {
      this.update();
    }

    update() {
      this.updateButtons();
      this.updateScrollbar();
    }

    updateButtons() {
      if (!this.viewport) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      sliderUtils.updateButtonState(this.prevButton, !hasOverflow || current <= 1);
      sliderUtils.updateButtonState(this.nextButton, !hasOverflow || current >= maxScroll - 1);
    }

    updateScrollbar() {
      if (!this.viewport || !this.scrollbar || !this.thumb) return;

      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      sliderUtils.updateScrollbar({
        viewport: this.viewport,
        scrollbar: this.scrollbar,
        thumb: this.thumb,
        enabled: hasOverflow
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-product-related-items]").forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new AWProductRelatedItems(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-product-related-items]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroy(event.target);
  });
})();
